import { Record } from "immutable";

const defaults = {
    active: false,
    brand_id: undefined,
    code: "",
    display_name: "",
    fake: false,
    id: undefined,
    sort: 0,
    allows_overselling: true,
    created_on: undefined,
};

export class Warehouse extends Record(defaults) {
    declare active: boolean;
    declare id: string;
    declare display_name: string;
    declare fake: boolean;
    declare allows_overselling: boolean;
    declare created_on: string;
}
